/**
 * Helper function to build list of available members for adding to a conversation.
 */

import type { ConversationParticipants } from '@saaga/shared/interfaces/conversation.interface'

import type { SelectableMember } from '@/components/chat/add-participant-member-list.molecule'
import type { UserLookupMap } from '@/hooks/use-org-members-lookup.hook'

interface BuildAvailableMembersParams {
  userLookup: UserLookupMap
  participants: ConversationParticipants | undefined
  currentUserId: string | undefined
}

export const buildAvailableMemberList = ({
  userLookup,
  participants,
  currentUserId,
}: BuildAvailableMembersParams): SelectableMember[] => {
  const memberList: SelectableMember[] = []
  const existingParticipantIdSet = new Set(Object.keys(participants ?? {}))

  for (const [userId, userData] of userLookup.entries()) {
    if (userId === currentUserId) continue
    if (existingParticipantIdSet.has(userId)) continue

    memberList.push({
      id: userId,
      name: userData.name,
      avatarUrl: userData.avatarUrl,
    })
  }

  return memberList.sort((a, b) => a.name.localeCompare(b.name))
}
